module.exports = __webpack_public_path__ + "img/upv.0c911b11.png";